module.exports = __webpack_public_path__ + "static/media/chat-screen_2.ebf0a80d.png";